import { Elm } from "./src/Main.elm";

var app = Elm.Main.init({
  node: document.querySelector("main"),
  flags: "test"
});

app.ports.inputTextSelect.subscribe(function (id) {
  window.requestAnimationFrame(() => {
    return document.getElementById(id).select();
  });
});

app.ports.selectOptionIndex.subscribe(function ({id, index}) {
  // Waits for the next animation frame to do the DOM manipulation
  // otherwise the Elm virtual DOM messes it up
  window.requestAnimationFrame(() => {
    console.log("test")
    return document.getElementById(id).value = index;
  });
});
